class Event {
    constructor() {
        this._callbacks = new Set();
    }

    listen(callback) {
        this._callbacks.add(callback);
    }

    unlisten(callback) {
        this._callbacks.delete(callback);
    }

    fire(...args) {
        for (let callback of this._callbacks) {
            callback(...args);
        }
    }
}

export default Event;
